import React, { FC } from "react";
import classNames from "classnames";
import { Subscribe } from "./components/subscribe/Subscribe";
import { AppStoreLinks } from "./components/app-store-links/AppStoreLinks";
import { Navigation } from "./components/navigation/Navigation";
import { SocialMedia } from "./components/social-media/SocialMedia";
import { LegalAndTerms } from "./components/legal-and-terms/LegalAndTerms";
import { Disclaimers } from "./components/disclaimers/Disclaimers";
import { NavigationContainer } from "./components/navigation-container/NavigationContainer";
import { Meta } from "./components/meta/Meta";

export const Footer: FC = () => (
  <footer>
    <Subscribe />
    <div
      className={classNames(
        "bg-dark px-5 py-20 text-neutral-content",
        "lg:px-16 lg:py-25",
        "xl:px-24",
      )}
    >
      <div className={"xl:mx-auto xl:max-w-container"}>
        <NavigationContainer
          className={classNames(
            "mb-20 gap-y-10",
            "md:mb-25 md:gap-y-15",
            "xxl:mb-[140px]",
          )}
        >
          <div
            className={classNames(
              "sm:col-span-2",
              "md:col-span-4",
              "xxl:col-span-1",
            )}
          >
            <AppStoreLinks />
          </div>
          <Navigation />
        </NavigationContainer>
        <NavigationContainer
          className={classNames(
            "gap-y-5 border-b border-solid border-divider pb-10",
          )}
        >
          <div
            className={classNames(
              "pb-5",
              "sm:col-span-2",
              "md:col-span-4",
              "xxl:col-span-1 xxl:pb-0",
            )}
          >
            <SocialMedia />
          </div>
          <LegalAndTerms />
        </NavigationContainer>
        <Disclaimers />
        <Meta />
      </div>
    </div>
  </footer>
);
